module.exports = __webpack_public_path__ + "static/media/icon_prev_blue.1ab36160.svg";